import * as React from 'react';
import Modal from 'react-modal';

// @ts-ignore
import AddedDeviceVerifierModal from 'app/components/AddedDeviceVerifierModal';
import DeviceSettingsItemTemplate from './DeviceSettingsItemTemplate';
import { DeviceSettingsPendingSMSDevice } from '../DeviceSettings';
import EventTracking from 'lib/EventTracking';
import Link from 'components/Link';
import Text from 'components/Text';

export type Props = {
  pendingSMSDevice: DeviceSettingsPendingSMSDevice;
  refetch: () => void;
};

type State = {
  verifierModalIsOpen: boolean;
};

export default class DeviceSettingsPendingSMSItem extends React.Component<Props, State> {
  state = {
    verifierModalIsOpen: false,
  };

  showVerifierModal = () => {
    this.setState({ verifierModalIsOpen: true });
  };

  hideVerifierModal = () => {
    this.setState({ verifierModalIsOpen: false });
  };

  render() {
    const { pendingSMSDevice } = this.props;

    return (
      <React.Fragment>
        <Modal isOpen={this.state.verifierModalIsOpen}>
          <AddedDeviceVerifierModal
            onRequestHide={this.hideVerifierModal}
            pendingSmsDeviceId={pendingSMSDevice.id}
            refetch={this.props.refetch}
          />
        </Modal>
        <DeviceSettingsItemTemplate
          deviceType="sms"
          deviceExists
          primaryTextLabel={pendingSMSDevice.label}
          secondaryTextLabel={
            <Text>
              This device has not yet been verified.{' '}
              <Link
                data-test="verify-reject-number-link"
                onClick={() => {
                  this.showVerifierModal();
                  EventTracking.trackKey('account_settings.call_preferences.verify_device.click');
                }}>
                Verify or reject number
              </Link>
            </Text>
          }
        />
      </React.Fragment>
    );
  }
}
